import { createAction, props } from '@ngrx/store';
import { TaskLegend } from 'app/models/api/color';

export enum ColorLegendsActionTypes {
  LoadPalette = '[ColorLegends] LoadPalette',
  LoadPaletteFail = '[ColorLegends] LoadPaletteFail',
  LoadPaletteSuccess = '[ColorLegends] LoadPaletteSuccess',
  UpdateTaskLegends = '[ColorLegends] UpdateTaskLegends',
  UpdateTaskLegendsFail = '[ColorLegends] UpdateTaskLegendsFail',
  UpdateTaskLegendsSuccess = '[ColorLegends] UpdateTaskLegendsSuccess'
}

export const loadPalette = createAction(ColorLegendsActionTypes.LoadPalette);
export const loadPaletteFail = createAction(ColorLegendsActionTypes.LoadPaletteFail, props<{ error: unknown }>());
export const loadPaletteSuccess = createAction(ColorLegendsActionTypes.LoadPaletteSuccess, props<{ palette: TaskLegend[] }>());
export const updateTaskLegends = createAction(
  ColorLegendsActionTypes.UpdateTaskLegends,
  props<{ legends: { id: string; description: string }[] }>()
);
export const updateTaskLegendsFail = createAction(ColorLegendsActionTypes.UpdateTaskLegendsFail, props<{ error: unknown }>());
export const updateTaskLegendsSuccess = createAction(ColorLegendsActionTypes.UpdateTaskLegendsSuccess);
